var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.series.some((v) => v > 0))?_c('apexchart',{attrs:{"type":"donut","height":"460","options":_vm.opts,"series":_vm.series}}):_c('div',{staticClass:"d-flex justify-center align-center grey--text text--lighten-1",staticStyle:{"min-height":"400px"}},[_c('span',{staticClass:"text-body-2"},[_vm._v(_vm._s(_vm.$t("no_data")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }